/**
 * OrbDocDownloadsCliAROrbDocDownloadsCliARPage
 *
 * Page component for OrbDocDownloadsCliAROrbDocDownloadsCliARPage
 * Path: /ar/docs/downloads/cli
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { OrbDocDownloadsCliARDocScreenView as __OrbDocDownloadsCliARDocScreenView } from '@/components/traits/OrbDocDownloadsCliARDocScreenView';
import { OrbDocDownloadsCliARDocAnalyticsView as __OrbDocDownloadsCliARDocAnalyticsView } from '@/components/traits/OrbDocDownloadsCliARDocAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface OrbDocDownloadsCliAROrbDocDownloadsCliARPageProps {
  // Add any page-level props here
}

export function OrbDocDownloadsCliAROrbDocDownloadsCliARPage(_props: OrbDocDownloadsCliAROrbDocDownloadsCliARPageProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":"أداة orb","description":"كل أوامر orb: التحقق والاختبار والترجمة والتشغيل والأدوات حولها.","access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/docs/downloads/cli"},{"locale":"ar","path":"/ar/docs/downloads/cli"},{"locale":"sl","path":"/sl/docs/downloads/cli"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__OrbDocDownloadsCliARDocScreenView config={{ initPayload: __navState }} />
          <__OrbDocDownloadsCliARDocAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default OrbDocDownloadsCliAROrbDocDownloadsCliARPage;
